import React, { useEffect } from 'react';
// import 'assets/css/style.scss';
import 'assets/css/tailwind.css';
import { createWrapper } from 'next-redux-wrapper';
import { appWithTranslation, i18n } from 'utils/with-i18next';

import { applyMiddleware, compose, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import reducer from '../reducer';
import RootSaga from '../redux/saga/RootSaga';
import handler from '../utils/sentry';

// 기본 언어를 수동으로 로드하는 함수
const loadDefaultLanguageResources = async () => {
  if (typeof window === 'undefined') return;

  const defaultLang = 'ko';
  const namespaces = ['common', 'index', 'login', 'myChannel', 'myAccount', 'error', 'invite', 'auth-success'];

  // 이미 로드되었는지 확인
  const existingBundle = i18n.getResourceBundle(defaultLang, 'common');
  if (existingBundle && Object.keys(existingBundle).length > 0) {
    return;
  }

  // 각 네임스페이스에 대해 번역 파일 로드
  for (const ns of namespaces) {
    try {
      const response = await fetch(`/static/locales/${defaultLang}/${ns}.json`);
      const data = await response.json();
      i18n.addResourceBundle(defaultLang, ns, data, true, true);
    } catch (error) {
      console.error(`Failed to load ${defaultLang}/${ns}:`, error);
    }
  }
};

const RootApp = ({ Component, pageProps }) => {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      handler();
    }

    // 콘솔에 BGMS 로고 표시
    console.log(
      `%c
██████╗  ██████╗ ███╗   ███╗███████╗
██╔══██╗██╔════╝ ████╗ ████║██╔════╝
██████╔╝██║  ███╗██╔████╔██║███████╗
██╔══██╗██║   ██║██║╚██╔╝██║╚════██║
██████╔╝╚██████╔╝██║ ╚═╝ ██║███████║
╚═════╝  ╚═════╝ ╚═╝     ╚═╝╚══════╝
      `,
      'color: #6366f1; font-weight: bold; font-size: 14px;'
    );

    // 기본 언어 리소스 로드
    loadDefaultLanguageResources();
  }, []);

  return (
    <React.Fragment>
      <Component {...pageProps}></Component>
    </React.Fragment>
  );
};

const configureStore = initialState => {
  const sagaMiddleware = createSagaMiddleware();
  const middlewares = [sagaMiddleware]; // 미들웨어들을 넣으면 된다.
  const enhancer =
    process.env.NODE_ENV === 'production'
      ? compose(applyMiddleware(...middlewares))
      : composeWithDevTools(applyMiddleware(...middlewares));
  const store = createStore(reducer, initialState, enhancer);
  sagaMiddleware.run(RootSaga);
  return store;
};

const wrapper = createWrapper(configureStore, { debug: false });

export default appWithTranslation(wrapper.withRedux(RootApp));
